import React, { useState, useEffect } from 'react';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { getQueryString } from '../../../utils/common';
import { Button, List, Modal, Icon, Switch, InputItem, Toast } from 'antd-mobile';
import { getCAPTCHA } from '../login/action';
import { API, ENV_TYPE } from '../../../env';
import './index.scss';
const HOST = API.COMMON_PORXY === '/LOCALAPI' ? '//api-fat.vphotos.cn' : API.COMMON_PORXY;
const AUTH_WECHAT_API = `${HOST}/gateway/vphoto-album/v1/copyright/getOAuthInfo`;
const BIND_PHONE_API = `${HOST}/gateway/vphoto-album/v1/copyright/bindWX`;
const CopyrightWXLogin = props => {
	let [isShowBind, setIsShowBind] = useState(false);
	let [disableSendCode, setDisableSendCode] = useState(false);
	let [countdownSeconds, setCountdownSeconds] = useState(0);
	const [pageData, setPageData] = useState({
		phone: '',
		code: ''
	});
	const [bindData, setbindData] = useState({});
	let codeStr = decodeURIComponent(getQueryString('code') || '');
	let dispatch = useDispatch();
	let [code, setCode] = useState(codeStr);
	useEffect(() => {
		async function fetchToken() {
			let res = await fetch(AUTH_WECHAT_API, {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ code })
			});
			if (res.status !== 200) {
				Toast.fail('登录失败，请重试', 2, () => {
					window.opener && window.opener.__WXLOGINWINDOW__.close();
				});
				return;
			}
			let json = await res.json();
			if (json.isBind) {
				window.opener && window.opener._WXLOGINCB_({ token: json.token, phone: json.phone, userId: json.userId });
				window.opener && window.opener.__WXLOGINWINDOW__.close();
			} else {
				setIsShowBind(true);
				let obj = {
					city: json.snsAuthInfo.city,
					headImgUrl: json.snsAuthInfo.headImgUrl,
					nickname: json.snsAuthInfo.nickname,
					sex: json.snsAuthInfo.sex,
					unionId: json.snsAuthInfo.unionId
				};
				setbindData(obj);
			}
		}
		fetchToken();
	}, [code]);
	function handlePhoneChange(val) {
		pageData.phone = val;
		console.log(val);
		console.log(pageData.phone);
		setPageData({ ...pageData });
	}
	function handleCodeChange(val) {
		pageData.code = val;
		setPageData({ ...pageData });
	}
	function validInput(phone, code) {
		phone = phone.trim();
		code = code.trim();
		if (!phone) {
			Toast.fail('手机号不能为空');
			return;
		}
		if (!code) {
			Toast.fail('验证码不能为空');
			return false;
		}
		let validPhone = /^1\d{10}$/.test(phone);
		let validCode = /^\d{6}$/.test(code);
		if (!validPhone) {
			Toast.fail('手机号格式错误');
			return false;
		}
		if (!validCode) {
			Toast.fail('验证码格式错误');
			return false;
		}
		return true;
	}
	async function bindPhone() {
		let phone = pageData.phone;
		let smsCode = pageData.code;
		if (!validInput(phone, smsCode)) {
			return;
		}
		let params = Object.assign({}, { phone, smsCode }, bindData);
		let res = await fetch(BIND_PHONE_API, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(params)
		});
		let json = await res.json();
		if (res.status !== 200 || !json.token) {
			Toast.fail(json.message || '绑定失败，请重试');
			return;
		}
		Toast.success('绑定成功');
		window.opener && window.opener._WXLOGINCB_({ token: json.token, phone, userId: json.userId });
		window.opener && window.opener.__WXLOGINWINDOW__.close();
	}
	function onClick() {
		window.opener._WXLOGINCB_({ token: 11, phone: 222, userId: 333 });
		window.opener && window.opener.__WXLOGINWINDOW__.close();
	}
	let timer = null;
	function getCode() {
		setDisableSendCode(true);
		dispatch(
			getCAPTCHA(
				{ phone: pageData.phone },
				data => {
					Toast.success('验证码已发送', 1);
					countdown();
					document.getElementsByTagName('input')[1].focus();
				},
				data => {
					console.log(document.getElementsByTagName('input')[0]);
					document.getElementsByTagName('input')[0].focus();
					Toast.fail('获取验证码失败', 1);
					clearInterval(timer);
					setDisableSendCode(false);
				}
			)
		);
	}
	function countdown() {
		countdownSeconds = 60;
		timer = setInterval(() => {
			countdownSeconds = countdownSeconds - 1;
			if (countdownSeconds === 0) {
				if (timer) {
					clearInterval(timer);
				}
				setDisableSendCode(false);
			}
			if (countdownSeconds <= 0) {
				countdownSeconds = 0;
			}
			setCountdownSeconds(countdownSeconds);
		}, 1000);
	}
	return (
		<div className="copyright copyright-wxlogin">
			<div className="wxlogin-inner">
				{!isShowBind ? (
					<span onClick={onClick}></span>
				) : (
					<div className="bind-phone">
						<img className="toutu-logo" src="https://gallerytemplate.oss-cn-hangzhou.aliyuncs.com/copyright/bind_phone.png" alt="投图"></img>
						<div className="bind-tit">您的账号未绑定手机，请先绑定</div>
						<section className="form">
							<InputItem value={pageData.phone} onChange={handlePhoneChange} placeholder="输入手机号" maxLength="11" prefixListCls="phone"></InputItem>
							<div className="code-wrapper">
								<InputItem value={pageData.code} onChange={handleCodeChange} placeholder="输入验证码" maxLength="6" prefixListCls="code"></InputItem>
								<div type="primary" className="get-code-btn" onClick={getCode}>
									获取验证码 {countdownSeconds ? `(${countdownSeconds})` : ''}
								</div>
							</div>
							<Button type="primary" className="bind" onClick={bindPhone}>
								绑定
							</Button>
						</section>
					</div>
				)}
			</div>
		</div>
	);
};
export { CopyrightWXLogin };
